import { AppError } from '@profile/src/redux/types';
export function formatErrorMessage(error) {
  switch (error) {
    case AppError.UNNKOWN:
      return 'Something went wrong.\nPlease try again later.';

    case AppError.WRONG_FORMAT:
      return 'Invalid code, try a different one.';

    case AppError.USER_NOT_FOUND:
      return 'User not found - something when wrong with accesstoken';

    case AppError.MISMATCH_TOKEN:
      return "You can't claim this token";

    case AppError.BUSY_SERVER:
      return 'Server is too busy now, try again later';

    case AppError.CLAIMED_TOKEN:
      return 'This token was claimed';

    default:
      return 'Something error happened try again later';
  }
}